ko.bindingHandlers.action = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, context)
    {
        const value = valueAccessor();
        
        if (value) value.IsBusy = ko.observable(false);

        //if (value._type === 'notImplemented') {
        //    element.classList.add('btn-warning')
        //   const t = tippy(element, {
        //        content: 'This action is not implemented yet!',
        //        theme: 'warning'
        //   });
        //    t.show();
        //}

         const wrappedValueAccessor = function ()
        {
            return function (data, event)
            {
                 
             const    value = valueAccessor()

                if (value && ('IsBusy' in value))
                    value.IsBusy(true)

                element.classList.add('loading')
                element.setAttribute('disabled', 'disabled')
                const promise = valueAccessor().call(viewModel, data, event);

                if (promise && ('then' in promise)) {
                    promise.finally(function ()
                    {
                        element.classList.remove('loading')
                        element.removeAttribute('disabled');


                        if (value && ('IsBusy' in value))
                            value.IsBusy(false)
                    })
                } else {
                    element.classList.remove('loading')
                    element.removeAttribute('disabled')

                    if (value && ('IsBusy' in value))
                        value.IsBusy(false)
                }
            };
        };
        ko.bindingHandlers.click.init(element, wrappedValueAccessor, allBindingsAccessor, viewModel, context);
    },
    update: ko.bindingHandlers.click.update,
    originalInit: ko.bindingHandlers.click.init
}
